import { z } from "zod"

import {
  AdjustmentHistorySortField,
  InventoryAdjustmentReason,
  InventoryAdjustmentStatus,
  InventoryAdjustmentType,
  SortingOrder,
} from "@/graphql/codegen/graphql"

export const adjustmentHistorySearchSchema = z.object({
  query: z.string().optional(),
  field: z.nativeEnum(AdjustmentHistorySortField).optional(),
  order: z.nativeEnum(SortingOrder).optional(),
  adjustmentTypes: z.array(z.nativeEnum(InventoryAdjustmentType)).optional(),
  adjustmentReasons: z.array(z.nativeEnum(InventoryAdjustmentReason)).optional(),
  statuses: z.array(z.nativeEnum(InventoryAdjustmentStatus)).optional(),
  warehouseAreaIds: z.array(z.string()).optional(),
  adjustedByIds: z.array(z.string()).optional(),
  dateFrom: z.string().nullish(),
  dateTo: z.string().nullish(),
})

export type AdjustmentHistorySearchParams = z.infer<typeof adjustmentHistorySearchSchema>
